import { Button, Col, Row, Typography } from 'antd';
import Title from 'antd/lib/typography/Title';

interface JoinMemberStep3Props {
  invitation: any;
  onSuccess: (data: any) => void;
}

function JoinMemberStep3({ invitation, onSuccess }: JoinMemberStep3Props) {
  const { Text } = Typography;
  return (
    <>
      <Row justify={'center'} style={{ marginTop: '10px' }}>
        <Col span={16}>
          <Title level={4}>
            {invitation.sender.enterpriseName}에서 {invitation.sender.userName}
            님이 초대했어요.
          </Title>
        </Col>
      </Row>
      <Row justify={'center'} style={{ marginTop: '20px' }}>
        <Col span={8}>
          <Button type="primary" style={{ width: '100%' }} onClick={onSuccess}>
            참여하기
          </Button>
        </Col>
      </Row>
      <Row justify={'center'} style={{ marginTop: '10px' }}>
        <Col>
          <Text>초대링크가 잘못 되었다면 소유자에게 문의하세요.</Text>
        </Col>
      </Row>
    </>
  );
}

export default JoinMemberStep3;
